import { useEDCFlow } from '@smvtech/x-flux';
import React from 'react'
import { Flag } from 'x-wings';
import { Flags } from 'x-wings/Components/Flag/types';

const Header = () => {
    const { order } = useEDCFlow();
    if(!order) return null;

    return (
        <div className="fixed inset-0 w-full h-16 z-20 flex items-center gap-3 px-6 bg-white border-b border-gray-200">
            <Flag code={order.country.symbol as Flags} size="m" hasBorder hasBorderRadius hasDropShadow />
            <span className="text-base text-gray-800 font-semibold tracking-[-0.12px]">
                {order.country.name}
            </span>
            <span className="text-3xl text-gray-300 font-medium">·</span>
            <span className="text-base text-[#525252] font-medium tracking-[-0.12px]">Visa Form</span>
        </div>
    )
}

export default Header